import { createMultiStyleConfigHelpers } from '~/utils/chakraUtils'

import { asChakraVariable } from '@mangovoice/design-system'
// import { textStyles } from '@mangovoice/design-system'
import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export const inputStyleParts = ['field'] as const

const helpers = createMultiStyleConfigHelpers(inputStyleParts)
export const InputStyle = helpers.defineMultiStyleConfig({
  variants: {
    mango: {
      field: {
        backgroundColor: 'bg.panel',
        color: 'fg.default',
        border: '1px solid',
        borderColor: 'border.default',
        borderRadius: '0.5rem',
        paddingX: '0.75rem',
        opacity: 1,
        outline: 'none',
        ...textStyles[textStyleKeys.Body1],
        fontSize: textStyles.Body1.fontSize,
        _placeholder: {
          color: 'fg.muted',
          ...textStyles[textStyleKeys.Body1],
        },
        _hover: {
          backgroundColor: 'bg.default',
          borderColor: 'border.default',
        },
        _active: {
          backgroundColor: 'bg.default',
        },
        _focus: {
          backgroundColor: 'bg.default',
          borderColor: 'border.default',
          boxShadow: asChakraVariable({ default: 'shadows.focus' }),
        },
        _invalid: {
          borderColor: 'red.solid',
        },
        _disabled: {
          opacity: 'none',
          borderColor: 'border.muted',
          backgroundColor: 'bg.muted',
          color: 'fg.muted',
          _hover: {
            borderColor: 'border.muted',
            backgroundColor: 'bg.muted',
          },
        },
      },
    },
    webPhoneModal: {},
  },
  defaultProps: {
    variant: 'mango',
  },
})
